export class ResponseError extends Error {
  public response: Response;
  public errors: any = null;
  code: number = 0;
  public message = '';

  constructor(response: Response) {
    super(response.statusText);
    this.response = response;
  }
}

export class ServerError extends ResponseError {}

export class UnprocessableEntityError extends ResponseError {
  constructor(response: any, info: any) {
    super(response);
    this.message = info.message ?? '';
    this.errors = info.reasons.messages;
  }
}

export class BadRequestError extends ResponseError {
  constructor(response: any, info: any) {
    super(response);
    this.message = info.message ?? '';
    this.code = response.code;
    this.errors = info.data;
  }
}

export class UnauthorizedError extends ResponseError {
  constructor(response: any, _info: any) {
    super(response);
    this.message = response.statusText ?? '';
  }
}

export class ForbiddenError extends ResponseError {
  constructor(response: any, info: any) {
    super(response);
    this.message = info.message ?? '';
  }
}

export class TeapotError extends ResponseError {
  constructor(response: any, info: any) {
    super(response);
    this.message = info.message ?? '';
  }
}
